import { render, staticRenderFns } from "./CLoadingOverlay.vue?vue&type=template&id=0a008a65&"
import script from "./CLoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./CLoadingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports